import { LooseObject } from '../../../interface';
import { IGroup } from '@antv/g-base';
import { ext } from '@antv/matrix-util';
import { deepMix } from '@antv/util';
import { parsePadding } from '../../../util/padding';
import Action from '../base';
const PADDING_RIGHT = 10;
const PADDING_TOP = 5;

/**
 * Button action
 * @ignore
 */
class ButtonAction extends Action {
  private buttonGroup: IGroup = null;
  private buttonCfg = {
    name: 'button',
    text: 'button',
    textStyle: {
      x: 0,
      y: 0,
      fontSize: 12,
      fill: '#333333',
      cursor: 'pointer',
    },
    padding: [8, 10],
    style: {
      fill: '#f7f7f7',
      stroke: '#cccccc',
      cursor: 'pointer',
    },
    activeStyle: {
      fill: '#e6e6e6',
    },
  };
  // mix é»è®¤çéç½®åç¨æ·éç½®
  private getButtonCfg(): LooseObject {
    return deepMix(this.buttonCfg, this.cfg);
  }
  // ç»å¶ Button å ææ¬
  private drawButton() {
    const config = this.getButtonCfg();
    const group = this.context.view.foregroundGroup.addGroup({
      name: config.name,
    });
    // æ·»å ææ¬
    const textShape = group.addShape({
      type: 'text',
      name: 'button-text',
      attrs: {
        text: config.text,
        ...config.textStyle,
      },
    });
    const textBBox = textShape.getBBox();
    const padding = parsePadding(config.padding);
    // æ·»å èæ¯æé®
    const buttonShape = group.addShape({
      type: 'rect',
      name: 'button-rect',
      attrs: {
        x: textBBox.x - padding[3],
        y: textBBox.y - padding[0],
        width: textBBox.width + padding[1] + padding[3],
        height: textBBox.height + padding[0] + padding[2],
        ...config.style,
      },
    });
    buttonShape.toBack(); // å¨åé¢
    // active ææåç½®
    group.on('mouseenter', () => {
      buttonShape.attr(config.activeStyle);
    });
    group.on('mouseleave', () => {
      buttonShape.attr(config.style);
    });
    this.buttonGroup = group;
  }

  // éç½®ä½ç½®
  private resetPosition() {
    const view = this.context.view;
    const coord = view.getCoordinate();
    const point = coord.convert({ x: 1, y: 1 }); // åé¢ç´æ¥æ¹æå·¦ä¸è§
    const buttonGroup = this.buttonGroup;
    const bbox = buttonGroup.getBBox();
    const matrix = ext.transform(null, [
      ['t', point.x - bbox.width - PADDING_RIGHT, point.y + bbox.height + PADDING_TOP],
    ]);
    buttonGroup.setMatrix(matrix);
  }

  /**
   * æ¾ç¤º
   */
  public show() {
    if (!this.buttonGroup) {
      this.drawButton();
    }
    this.resetPosition();
    this.buttonGroup.show();
  }

  /**
   * éè
   */
  public hide() {
    if (this.buttonGroup) {
      this.buttonGroup.hide();
    }
  }

  /**
   * éæ¯
   */
  public destroy() {
    const buttonGroup = this.buttonGroup;
    if (buttonGroup) {
      buttonGroup.remove();
    }
    super.destroy();
  }
}

export default ButtonAction;
